import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, MessageCircle } from "lucide-react";

const Footer = () => {
    const { t } = useApp();

    return (
        <footer data-testid="site-footer" className="mt-20 border-t border-border bg-[hsl(var(--royal-deep))] text-slate-100">
            <div className="container-x py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-3">
                        <div className="w-14 h-14 rounded-full bg-white p-1 shadow-md">
                            <img src="/logo.webp" alt="Sri Matha Multiservices" className="w-full h-full object-contain" />
                        </div>
                        <div>
                            <div className="text-base font-bold">Sri Matha</div>
                            <div className="text-[11px] uppercase tracking-[0.15em] text-slate-300">Multiservices · Estd 2009</div>
                        </div>
                    </div>
                    <p className="mt-4 text-sm text-slate-300 leading-relaxed">{t.footer.aboutDesc}</p>
                    <div className="mt-5 flex gap-3">
                        <a data-testid="social-fb" href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(var(--gold))] hover:text-slate-900 transition-colors" aria-label="Facebook"><Facebook size={16} /></a>
                        <a data-testid="social-ig" href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(var(--gold))] hover:text-slate-900 transition-colors" aria-label="Instagram"><Instagram size={16} /></a>
                        <a data-testid="social-yt" href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(var(--gold))] hover:text-slate-900 transition-colors" aria-label="YouTube"><Youtube size={16} /></a>
                        <a data-testid="social-wa" href="https://wa.me/919000767404" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(var(--gold))] hover:text-slate-900 transition-colors" aria-label="WhatsApp"><MessageCircle size={16} /></a>
                    </div>
                </div>

                <div>
                    <h4 className="text-sm font-semibold tracking-wide uppercase text-[hsl(var(--gold-light))] mb-4">{t.footer.quickLinks}</h4>
                    <ul className="space-y-2.5 text-sm">
                        <li><Link to="/about" className="text-slate-300 hover:text-white">{t.nav.about}</Link></li>
                        <li><Link to="/services" className="text-slate-300 hover:text-white">{t.nav.services}</Link></li>
                        <li><Link to="/forms" className="text-slate-300 hover:text-white">{t.nav.forms}</Link></li>
                        <li><Link to="/news" className="text-slate-300 hover:text-white">{t.nav.news}</Link></li>
                        <li><Link to="/booking" className="text-slate-300 hover:text-white">{t.nav.booking}</Link></li>
                        <li><Link to="/track" className="text-slate-300 hover:text-white">{t.nav.track}</Link></li>
                        <li><Link to="/gallery" className="text-slate-300 hover:text-white">{t.nav.gallery}</Link></li>
                        <li><Link to="/contact" className="text-slate-300 hover:text-white">{t.nav.contact}</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm font-semibold tracking-wide uppercase text-[hsl(var(--gold-light))] mb-4">{t.footer.legal}</h4>
                    <ul className="space-y-2.5 text-sm">
                        <li><Link to="/privacy" className="text-slate-300 hover:text-white">{t.footer.privacy}</Link></li>
                        <li><Link to="/terms" className="text-slate-300 hover:text-white">{t.footer.terms}</Link></li>
                        <li><Link to="/admin/login" className="text-slate-300 hover:text-white">{t.nav.adminLogin}</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm font-semibold tracking-wide uppercase text-[hsl(var(--gold-light))] mb-4">{t.footer.reach}</h4>
                    <ul className="space-y-3 text-sm">
                        <li className="flex gap-3 items-start"><MapPin size={16} className="mt-0.5 text-[hsl(var(--gold-light))]" /><span className="text-slate-300 leading-relaxed">13-65/B1, Matha Ghar, MeeSeva Center, Near IOCL Petrol Pump, MBNR Main Road, Janampeta, Mahabubnagar, Telangana – 509334</span></li>
                        <li className="flex gap-3 items-center"><Phone size={16} className="text-[hsl(var(--gold-light))]" /><a data-testid="footer-phone" href="tel:+919000767404" className="text-slate-300 hover:text-white">+91 9000767404</a></li>
                        <li className="flex gap-3 items-center"><Mail size={16} className="text-[hsl(var(--gold-light))]" /><a data-testid="footer-email" href="mailto:srimatha.multiservices@gmail.com" className="text-slate-300 hover:text-white break-all">srimatha.multiservices@gmail.com</a></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-x py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-300">
                    <div>© {new Date().getFullYear()} Sri Matha Multiservices. {t.footer.rights}</div>
                    <div>srimathamultiservices.com</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
